import React, { memo } from 'react'

import NftCard from './NftCard'
import GetFounderKey from './GetFounderKey'
import PageTitle from '../../../../components/shared/pageTitle/PageTitle'
import CardGridLayout from '../../../../components/shared/grid/CardGridLayout'
import SkeletonLoading from '../../../../components/nfts/SkeletonLoading'

const Wallet = ({ t, nfts, loading }) => {
  const pageTitle = t('brand:wallet.qbx-founders-key')
  return (
    <>
      <PageTitle
        title={pageTitle}
        desc={t('brand:wallet.qbx-founders-key-desc')}
      />
      <CardGridLayout>
        {loading ? (
          <SkeletonLoading />
        ) : nfts.length ? (
          nfts.map((nft, index) => <NftCard key={index} t={t} {...nft} />)
        ) : (
          <GetFounderKey t={t} />
        )}
      </CardGridLayout>
    </>
  )
}

export default memo(Wallet)
